export interface LessonContentProps {
  html: string | null;
}

/**
 * Renders a lesson's text body. Safe to inject: the server sanitizes `textHtml` against a whitelist
 * on every write, so what is stored is already the only markup we allow.
 *
 * Shares `.rich-text-content` with the editor, so authoring and reading look identical.
 */
const LessonContent = ({ html }: LessonContentProps) => {
  if (!html) return null;

  return <div className="rich-text-content text-[15px] leading-relaxed text-[#12282A]" dangerouslySetInnerHTML={{ __html: html }} />;
};

export default LessonContent;
